module.exports = __webpack_public_path__ + "static/media/fr_outdoor_hot_permacool.b6c9abd5.png";